import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from "axios";

const CustomerContext = createContext()

const CustomerProvider = ({ children }) => {
    const { headers, toast, restaurantId } = useAuth();

    //Get All Customers
    const getAllCustomers = async (currentPage, rowsPerPage, sortField, sortOrder, filter, isActive) => {
        try {
            let { data } = await axios.get(`${baseURL}/customer/list?&sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&filter=${filter}&restaurant_id=${restaurantId}&isActive=${isActive}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Customer', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //Get Single Customer
    const getSingleCustomer = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/customer/single-customer/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Customer', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //Create Customer
    const createCustomer = async (customerDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/customer/create`, customerDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Customer', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Customer', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Customer', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Customer', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Customer', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    //Update Customer
    const updateCustomer = async (id, customerDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/customer/update/${id}`, customerDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Customer', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Customer', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Customer', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Customer', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Customer', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    //Delete Customer
    const deleteCustomer = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/customer/delete/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Customer', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Customer', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Customer', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //Archive Customer
    const archiveCustomer = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/customer/archive/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Customer', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Customer', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Customer', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //Reset Credits
    const resetCredits = async (customers) => {
        try {
            const response = await axios.post(`${baseURL}/customer/reset-credits`, { customers }, { headers });

            if (response.data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Customer', detail: response.data.message, life: 3000 });
                }, 500);
                getAllCustomers();
                return response.data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Customer', detail: response.data.message, life: 3000 });
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Customer', detail: 'An error occurred. Please try again later.', life: 3000 });
        }
    };

    //Deactivate Customer
    const manageIsActiveCustomer = async (customers) => {
        try {
            const response = await axios.post(`${baseURL}/customer/manage-is-active-customer`, { customers }, { headers });

            if (response.data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Customer', detail: response.data.message, life: 3000 });
                }, 500);
                getAllCustomers();
                return response.data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Customer', detail: response.data.message, life: 3000 });
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Customer', detail: 'An error occurred. Please try again later.', life: 3000 });
        }
    };

    return (
        <CustomerContext.Provider value={{ getAllCustomers, getSingleCustomer, createCustomer, updateCustomer, deleteCustomer, archiveCustomer, resetCredits, manageIsActiveCustomer }}>
            {children}
        </CustomerContext.Provider>
    )
}

const useCustomer = () => useContext(CustomerContext)

export { useCustomer, CustomerProvider }